export default __webpack_public_path__ + "static/media/logo_wc.42d6acdf.png";